import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";
import * as dashboardActions from "./dashboard.actions";
import { DashboardService } from "src/app/admin/dashboard/dashboard.service";

@Injectable()
export class DashboardEffects {
  loadDashboardData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(dashboardActions.loadDashboardData),
      mergeMap(({ projectId }) =>
        this.dashboardService.getDashboard_Data(projectId).pipe(
          map((dashboardData) =>
            dashboardActions.loadDashboardDataSuccess({ dashboardData })
          ),
          catchError((error) =>
            of(dashboardActions.loadDashboardDataFailure({ error }))
          )
        )
      )
    )
  );
  loadAllocatedProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(dashboardActions.loadAllocatedProjects),
      mergeMap(() =>
        this.dashboardService.getAllocatedProjects().pipe(
          map((projects) =>
            dashboardActions.loadAllocatedProjectsSuccess({
              allocatedProjects: projects,
            })
          ),
          catchError((error) =>
            of(dashboardActions.loadAllocatedProjectsFailure({ error }))
          )
        )
      )
    )
  );
  constructor(
    private actions$: Actions,
    private dashboardService: DashboardService
  ) {}
}
